import * as React from 'react';
import { hasSoldOut, priceAvailability } from '../../helpers/priceHelpers';
import { replacePlaceholders, __ } from '../../helpers/TranslationService';
import { ICabinInfo, ISoldOutBooking } from '../../interfaces';
import { Button } from '../Button/Button';
import { Link } from '../Link';
import styled from '@emotion/styled';

const PriceSectionWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
`;

const PriceDiscountWrapper = styled.div`
    font-size: 14px;
    color: ${({ theme }) => theme.colors.watermelon[100]};
    font-weight: 700;
    line-height: 24px;
`;

const PriceWrapper = styled.div`
    font-size: 20px;
    font-weight: 700;
    line-height: 32px;
`;

const PriceSoldOut = styled(PriceWrapper)``;

interface IProps {
    url: string;
    perPersonPrice: number;
    discountPercentage: number;
    currency: string;
    isButtonShown: boolean;
    departure: number;
    soldOutBooking: ISoldOutBooking;
    discountThreshold: number;
    cabin?: ICabinInfo;
    numberOfPassengers?: number;
}

export function CabinDetailsPriceSection(props: IProps) {
    const {
        departure,
        soldOutBooking,
        perPersonPrice,
        currency,
        cabin,
        numberOfPassengers,
        discountPercentage,
        discountThreshold,
        isButtonShown,
    } = props;
    const price = priceAvailability(
        departure,
        soldOutBooking,
        perPersonPrice,
        currency,
        cabin,
        numberOfPassengers,
    );
    const isDisabled = hasSoldOut(departure, soldOutBooking, perPersonPrice);
    const hasDiscount = discountThreshold
        ? discountPercentage >= discountThreshold
        : discountPercentage > 0;

    if (!price || !price.valid) {
        return (
            <PriceSectionWrapper>
                <PriceSoldOut>{price.string || __('on request', 'dreamlines')} </PriceSoldOut>
            </PriceSectionWrapper>
        );
    }

    return (
        <PriceSectionWrapper>
            <div>
                {hasDiscount && (
                    <PriceDiscountWrapper>
                        {replacePlaceholders(__('upToXDiscount', 'dreamlines'), [
                            `-${discountPercentage}%`,
                        ])}
                    </PriceDiscountWrapper>
                )}
                <PriceWrapper>
                    {price.string}{' '}
                    {!Number.isNaN(Number.parseInt(price.string, 10)) && __('p.P.', 'dreamlines')}
                </PriceWrapper>
            </div>
            {isButtonShown && !isDisabled && (
                <Link href={props.url} mask={true}>
                    <Button>{__('Select', 'dreamlines')}</Button>
                </Link>
            )}
        </PriceSectionWrapper>
    );
}
